<template>
    <div id="app">
      <router-view></router-view>
      <lg-preview></lg-preview>
    </div>
</template>

<script>
    export default {
        name: "App"
    }
</script>

<style scoped  lang="less" rel="stylesheet/less">
</style>



// WEBPACK FOOTER //
// src/App.vue